import { withWindow } from '@shared/utils/withWindow';

export const isMac = withWindow(w => /Mac|iPhone|iPad|iPod/i.test(w.navigator.userAgent), false);

export const shortcutLabel = isMac ? '⌘K' : 'Ctrl+K';

/**
 * Tracks how the command menu was opened so the correct trigger value
 * is logged in telemetry. Defaults to 'keyboard'; the search button
 * sets it to 'button' before calling toggle, and AdminCommandMenu
 * reads + resets it on open.
 */
export let nextOpenTrigger: 'keyboard' | 'button' = 'keyboard';

export function setNextOpenTrigger(trigger: 'keyboard' | 'button') {
  nextOpenTrigger = trigger;
}

export function consumeNextOpenTrigger(): 'keyboard' | 'button' {
  const trigger = nextOpenTrigger;
  nextOpenTrigger = 'keyboard';
  return trigger;
}
